import React from 'react';

export default ({ color = '#221CB6' }) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.49902 2.58333V1"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.37402 11.2917V4.16667C2.37402 3.29222 3.08291 2.58333 3.95736 2.58333H15.0407C15.9152 2.58333 16.624 3.29222 16.624 4.16667V11.2917"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.249 18.0208L11.874 14.4583L12.1379 14.8542"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.74902 18.0208L7.12402 14.4583L6.86014 14.8542"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49902 14.4583V16.8333"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.54102 9.70833L7.91602 7.33333L10.291 9.70833L13.4577 6.54167"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2077 14.4583H0.791016"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
